import React, { useEffect, useState, useContext, useRef } from 'react'
import { PriceComparisonContext, IPriceComparisonContext } from '../PriceComparison'

// MUI
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

const ProductDescription = ({ text }: { text: string }) => {
  const [divHeight, setDivHeight] = useState<number>(0)
  const container = useRef<HTMLDivElement | null>(null)

  const { descriptionHeight, setDescriptionHeight }: IPriceComparisonContext =
    useContext<IPriceComparisonContext>(PriceComparisonContext)

  useEffect(() => {
    const elementHeight = container.current?.getBoundingClientRect().height

    if (setDescriptionHeight && elementHeight && elementHeight > descriptionHeight) {
      setDescriptionHeight(elementHeight)
    }

    setDivHeight(descriptionHeight)

    return () => {
      // Cleanup function
      setDivHeight(0)
    }
  }, [descriptionHeight])

  const { breakpoints } = useTheme()
  const styles = {
    root: {
      marginBottom: '12px',
      [breakpoints.up('md')]: {
        minHeight: divHeight,
      },
    },
  }
  return (
    <Box ref={container} sx={styles.root}>
      <Typography variant="body1">{text}</Typography>
    </Box>
  )
}

export default ProductDescription
